import { trackEvent } from '@fiverr-private/gtm';

const GTM_EVENTS = {
    CONTACT_SELLER_CLICKED: 'contact_me_clicked',
};

export const contactMeClicked = () => trackEvent(GTM_EVENTS.CONTACT_SELLER_CLICKED);
